import { configureStore, createSelector } from "@reduxjs/toolkit";

import appReducer from "./slices/appSlice";
import sourceReducer from "./slices/sourceSlice";
import userReducer from "./slices/userSlice";
import impersonationReducer from "./slices/impersonationSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    source: sourceReducer,
    user: userReducer,
    impersonation: impersonationReducer,
  },
});
